import { Routes, RouterModule, ActivatedRouteSnapshot } from '@angular/router';
import { NgModule, inject } from '@angular/core';
import { AuthGuard } from '@services/auth.guard';
import { ErrorNotFoundComponent } from './errors/error-notfound/error-notfound.component';
import { ErrorNoStudyAccessComponent } from './errors/error-nostudyaccess/error-nostudyaccess.component';
import { LoggedOutComponent } from './auth/logged-out/logged-out.component';
import { PrivacyNoticeComponent } from './privacynotice/privacynotice.component';
import { ErrorPrivacyNoticeComponent } from './errors/error-privacynotice/error-privacynotice.component';
import { StudyBydateRangeComponent } from './study-bydate-range/study-bydate-range.component';

export const routes: Routes = [
  { path: '', redirectTo: 'study', pathMatch: 'full' },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthGuard).canActivate(route)],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthGuard).canActivate(route)],
  },
  {
    path: 'study',
    loadChildren: () => import('./mystudies/mystudies.module').then((m) => m.MyStudiesModule),
    canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthGuard).canActivate(route)],
  },
  {
    path: 'search',
    loadChildren: () => import('./searchstudies/searchstudies.module').then((m) => m.SearchStudiesModule),
    canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthGuard).canActivate(route)],
  },
  {
    path: 'users',
    loadChildren: () => import('./users/users.module').then((m) => m.UsersModule),
    canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthGuard).canActivate(route)],
  },
  { path: 'loggedout', component: LoggedOutComponent },
  { path: 'nostudyaccess', component: ErrorNoStudyAccessComponent },
  { path: 'cancelprivacynotice', component: ErrorPrivacyNoticeComponent },
  { path: 'privacynotice', component: PrivacyNoticeComponent },
  {
    path: 'report/studybydate', // The route path
    loadChildren: () => import('./study-bydate-range/study-bydate-range.module').then((m) => m.StudyBydateRangeModule),
    canActivate: [(route: ActivatedRouteSnapshot) => inject(AuthGuard).canActivate(route)],
  },
  { path: '**', component: ErrorNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
